module.exports = __webpack_public_path__ + "static/media/assignments.66854616.png";